import { createCachedSelector, defaultKeySelector, path } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { detailsSidebarStoreSelector } from '@cbridge-packages/details-sidebar';

export const detailsSidebarModeSelector = createCachedSelector(
  [
    path(detailsSidebarStoreSelector).mode(),
  ],
  (mode) => {
    return mode;
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
